import type { ReactElement } from 'react';
import type { ObjectValues, TextAreaHtmlProps } from '../types';

export const themes = {
  light: 'light',
  dark: 'dark',
} as const;

export const sizes = {
  default: 'default',
  small: 'small',
} as const;

export type TextArea = {
  helpText?: string;
  label: string;
  theme?: ObjectValues<typeof themes>;
  size?: ObjectValues<typeof sizes>;
  isLabelVisible?: boolean;
  helpIcon?: ReactElement;
  isShort?: boolean;
  name: string;
  defaultValue?: string;
} & TextAreaHtmlProps;
